import * as React from "react";

import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";
import { isNextStyleEnabled } from "@1js/acui-theme";

export const useV9RibbonControlsEnabled = () => {
  const appContext = React.useContext(AppContext);
  return (
    isNextStyleEnabled() &&
    checkExperiment(
      appContext,
      ribbonExperiments.fluentV9RibbonControlsIsEnabled
    )
  );
};

export const useNewV9RibbonMenuEnabled = (_id?: string) => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(appContext, ribbonExperiments.newV9RibbonMenuEnabled);
};
